import { ExampleApiUsage } from "@/Features/Drydock/examples/ExampleApiUsage";
import { ExampleVariantGroup } from "@/Features/Drydock/examples/ExampleVariantGroup";
import Divider from "@common/Divider";

export const SampleAPI = () => {
    return (
        <div>
            <ExampleApiUsage />
            <Divider />
            <ExampleVariantGroup />
        </div>
    );
};
